module.exports = __webpack_public_path__ + "static/delivery/img/rider_head.ca764609.png";